<template>
    <div>
        <div>
            <v-row>
                <v-col cols="12">
                    <ViewAttachInformation />
                </v-col>
            </v-row>
        </div>
        <v-row class="mt-10">
            <v-col cols="12" sm="4" md="6">
                <div class="headline">Pending Case Agging</div>
            </v-col>

            <v-col cols="12" sm="4" md="3" class="text-right">
                <v-autocomplete
                    chips
                    v-model="form_agging_case.project"
                    :items="data_filter.projects"
                    label="Select Project"
                    item-text="project_name"
                    item-value="project_id"
                    @change="get_summary_case(1)"
                    multiple
                    outlined
                    dense
                >
                    <template
                        v-slot:selection="{
                            item,
                            index,
                        }"
                    >
                        <v-chip v-if="index === 0">
                            <span>{{ item.project_name }}</span>
                        </v-chip>
                        <span v-if="index === 1" class="grey--text caption"
                            >(+{{
                                form_agging_case.project.length - 1
                            }}
                            others)</span
                        >
                    </template>
                    <template v-slot:prepend-item>
                        <v-list-item ripple @click="toggle">
                            <v-list-item-action>
                                <v-icon
                                    :color="
                                        form_agging_case.project.length > 0
                                            ? 'indigo darken-4'
                                            : ''
                                    "
                                    >{{ icon }}</v-icon
                                >
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title
                                    >Select All</v-list-item-title
                                >
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2"></v-divider>
                    </template>

                    <template v-slot:append-item>
                        <v-divider class="mb-2"></v-divider>
                        <v-list-item disabled>
                            <v-list-item-avatar color="grey lighten-3">
                                <v-icon>mdi-folder-plus</v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content v-if="likesAllProject">
                                <v-list-item-title
                                    >Select All Project</v-list-item-title
                                >
                            </v-list-item-content>

                            <v-list-item-content v-else-if="likesSomeProject">
                                <v-list-item-title
                                    >Project Count</v-list-item-title
                                >
                                <v-list-item-subtitle>{{
                                    form_agging_case.project.length
                                }}</v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-content v-else> </v-list-item-content>
                        </v-list-item>
                    </template>
                </v-autocomplete>
            </v-col>
            <v-col cols="12" sm="4" md="3">
                <v-autocomplete
                    chips
                    v-model="form_agging_case.branch"
                    :items="data_filter.branchs"
                    label="Select Zone"
                    item-text="branch_name"
                    item-value="branch_id"
                    @change="get_summary_case(1)"
                    multiple
                    outlined
                    dense
                >
                    <template
                        v-slot:selection="{
                            item,
                            index,
                        }"
                    >
                        <v-chip v-if="index === 0">
                            <span>{{ item.branch_name }}</span>
                        </v-chip>
                        <span v-if="index === 1" class="grey--text caption"
                            >(+{{
                                form_agging_case.branch.length - 1
                            }}
                            others)</span
                        >
                    </template>
                    <template v-slot:prepend-item>
                        <v-list-item ripple @click="toggle_zone">
                            <v-list-item-action>
                                <v-icon
                                    :color="
                                        form_agging_case.branch.length > 0
                                            ? 'indigo darken-4'
                                            : ''
                                    "
                                    >{{ icon_zone }}</v-icon
                                >
                            </v-list-item-action>
                            <v-list-item-content>
                                <v-list-item-title
                                    >Select All</v-list-item-title
                                >
                            </v-list-item-content>
                        </v-list-item>
                        <v-divider class="mt-2"></v-divider>
                    </template>
                    <template v-slot:append-item>
                        <v-divider class="mb-2"></v-divider>
                        <v-list-item disabled>
                            <v-list-item-avatar color="grey lighten-3">
                                <v-icon>mdi-folder-plus</v-icon>
                            </v-list-item-avatar>

                            <v-list-item-content v-if="likesAllZone">
                                <v-list-item-title
                                    >Select All Zone</v-list-item-title
                                >
                            </v-list-item-content>

                            <v-list-item-content v-else-if="likesSomeZone">
                                <v-list-item-title
                                    >Zone Count</v-list-item-title
                                >
                                <v-list-item-subtitle>{{
                                    form_agging_case.branch.length
                                }}</v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-content v-else> </v-list-item-content>
                        </v-list-item>
                    </template>
                </v-autocomplete>
            </v-col>
        </v-row>
        <div id="case-summary" class="mar-t-20">
            <v-row>
                <v-col cols="12" v-if="data_summary_case.length == 0">
                    <v-progress-linear
                        indeterminate
                        color="cyan"
                    ></v-progress-linear>
                </v-col>
                <v-col
                    cols="12"
                    sm="6"
                    md="4"
                    lg="3"
                    class="cur-p"
                    v-for="(row_sum, index_sum) in data_summary_case"
                    :key="index_sum"
                >
                    <v-card @click="change_statusall(index_sum)">
                        <v-list-item two-line>
                            <v-list-item-content>
                                <b style="font-size:15px;">{{
                                    row_sum.title
                                }}</b>
                            </v-list-item-content>
                            <v-btn
                                elevation="0"
                                fab
                                dark
                                small
                                :color="
                                    chk_active_all === index_sum
                                        ? 'teal accent-3'
                                        : 'grey lighten-1'
                                "
                                >{{ row_sum.num }}</v-btn
                            >
                        </v-list-item>
                        <v-system-bar
                            :height="4"
                            dark
                            :color="
                                chk_active_all === index_sum
                                    ? 'teal accent-3'
                                    : 'white'
                            "
                        >
                        </v-system-bar>
                    </v-card>
                </v-col>
            </v-row>
        </div>

        <div id="case-agging">
            <v-row>
                <v-col cols="12">
                    <v-progress-linear
                        v-if="data_agging_case.length == 0"
                        indeterminate
                        color="cyan"
                    ></v-progress-linear>
                </v-col>
            </v-row>
            <v-row class="" v-if="data_agging_case.length != 0">
                <v-col cols="12" class="mar-t-20">
                    <v-simple-table class="table-inv">
                        <template v-slot:default>
                            <thead>
                                <tr class="col-tr-1">
                                    <th class="text-center" rowspan="2">
                                        Status
                                    </th>
                                    <th
                                        class="text-center"
                                        :colspan="
                                            data_agging_case.agging_group
                                                .length + 1
                                        "
                                    >
                                        Case Ageing
                                    </th>
                                </tr>
                                <tr class="col-tr-1">
                                    <th
                                        class="text-center"
                                        v-for="(row2,
                                        index2) in data_agging_case.agging_group"
                                        :key="index2"
                                    >
                                        {{ row2 }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody
                                v-for="(r2, i2) in data_agging_case.summary"
                                :key="i2"
                            >
                                <tr class="bg-tr-1">
                                    <td
                                        :colspan="
                                            data_agging_case.agging_group
                                                .length + 1
                                        "
                                    >
                                        <b>{{ r2.project_name }}</b>
                                    </td>
                                </tr>
                                <tr v-for="(r22, i22) in r2.status" :key="i22">
                                    <td>{{ r22.status_name }}</td>
                                    <td
                                        v-for="(r222, i222) in r22.agging"
                                        :key="i222"
                                        class="text-right"
                                    >
                                        <div
                                            :style="'color:' + colorx[i222]"
                                            :class="
                                                r222.num_cases > 0
                                                    ? 'fix-td-1 cur-p'
                                                    : 'fix-td-1'
                                            "
                                            @click="
                                                change_agging(
                                                    i222,
                                                    r22.status_name,
                                                    r2.project_name,
                                                    r222.num_cases
                                                )
                                            "
                                        >
                                            {{ r222.num_cases }}
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-row>
            <v-row class="mar-t-30" v-if="data_agging_case.length != 0">
            </v-row>
        </div>

        <div id="admin-performance">
            <v-row>
                <v-col cols="12">
                    <v-progress-linear
                        v-if="data_admin_performance.length == 0"
                        indeterminate
                        color="cyan"
                    ></v-progress-linear>
                </v-col>
            </v-row>
            <v-row v-if="data_admin_performance.length != 0" class="mt-10">
                <v-col cols="12" sm="8" md="9">
                    <div class="headline">Admin Performance</div>
                </v-col>
                <v-col cols="12" sm="4" md="3" class="text-right">
                    <div class="headline">
                        <v-menu
                            v-model="menudate2"
                            :close-on-content-click="false"
                            :nudge-right="40"
                            transition="scale-transition"
                            offset-y
                        >
                            <template v-slot:activator="{ on }">
                                <v-text-field
                                    outlined
                                    dense
                                    v-model="dateRangeText2"
                                    label="Date Admin Performance"
                                    readonly
                                    v-on="on"
                                ></v-text-field>
                            </template>
                            <v-date-picker
                                v-model="form_admin_performance.date"
                                range
                                @change="get_date(2)"
                            ></v-date-picker>
                        </v-menu>
                    </div>
                </v-col>
                <v-col cols="12" class="mar-t-30">
                    <BarChart :dataBar="data_admin_performance" />
                </v-col>
            </v-row>
        </div>

        <div id="case-summary">
            <v-progress-linear
                v-if="chk_data_engineer_performance == true"
                indeterminate
                color="cyan"
                class="mt-3"
            ></v-progress-linear>
            <v-row v-if="chk_data_engineer_performance == false">
                <v-col cols="12" md="5">
                    <div class="headline">Engineer Performance</div>
                </v-col>
                <v-col cols="5" md="3" class="text-rigth">
                    <v-menu
                        v-model="menudate3"
                        :close-on-content-click="false"
                        :nudge-right="40"
                        transition="scale-transition"
                        offset-y
                    >
                        <template v-slot:activator="{ on }">
                            <v-text-field
                                outlined
                                dense
                                v-model="dateRangeText3"
                                label="Date Onsite"
                                readonly
                                v-on="on"
                            ></v-text-field>
                        </template>
                        <v-date-picker
                            v-model="form_engineer_performance.date"
                            range
                            @change="get_date(3)"
                        ></v-date-picker>
                    </v-menu>
                </v-col>

                <v-col cols="5" md="3">
                    <v-autocomplete
                        chips
                        v-model="form_engineer_performance.branch"
                        :items="data_filter.branchs"
                        label="Select Zone"
                        item-text="branch_name"
                        item-value="branch_id"
                        @change="get_engineer_performance(1)"
                        multiple
                        outlined
                        dense
                    >
                        <template
                            v-slot:selection="{
                                item,
                                index,
                            }"
                        >
                            <v-chip v-if="index === 0">
                                <span>{{ item.branch_name }}</span>
                            </v-chip>
                            <span v-if="index === 1" class="grey--text caption"
                                >(+{{
                                    form_engineer_performance.branch.length - 1
                                }}
                                others)</span
                            >
                        </template>
                        <template v-slot:prepend-item>
                            <v-list-item ripple @click="toggle_zone2">
                                <v-list-item-action>
                                    <v-icon
                                        :color="
                                            form_engineer_performance.branch
                                                .length > 0
                                                ? 'indigo darken-4'
                                                : ''
                                        "
                                        >{{ icon_zone }}</v-icon
                                    >
                                </v-list-item-action>
                                <v-list-item-content>
                                    <v-list-item-title
                                        >Select All</v-list-item-title
                                    >
                                </v-list-item-content>
                            </v-list-item>
                            <v-divider class="mt-2"></v-divider>
                        </template>
                        <template v-slot:append-item>
                            <v-divider class="mb-2"></v-divider>
                            <v-list-item disabled>
                                <v-list-item-avatar color="grey lighten-3">
                                    <v-icon>mdi-folder-plus</v-icon>
                                </v-list-item-avatar>

                                <v-list-item-content v-if="likesAllZone2">
                                    <v-list-item-title
                                        >Select All Zone</v-list-item-title
                                    >
                                </v-list-item-content>

                                <v-list-item-content v-else-if="likesSomeZone2">
                                    <v-list-item-title
                                        >Zone Count</v-list-item-title
                                    >
                                    <v-list-item-subtitle>{{
                                        form_engineer_performance.branch.length
                                    }}</v-list-item-subtitle>
                                </v-list-item-content>

                                <v-list-item-content v-else>
                                </v-list-item-content>
                            </v-list-item>
                        </template>
                    </v-autocomplete>
                </v-col>
                <v-col cols="1" v-if="role_name != 'Admin'">
                    <v-tooltip left>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                fab
                                small
                                :color="
                                    chk_export_engineer_performance == false
                                        ? 'green accent-3'
                                        : ''
                                "
                                class="mr-1"
                                :disabled="
                                    chk_export_engineer_performance == true
                                "
                                @click="export_engineer_performance()"
                                v-bind="attrs"
                                v-on="on"
                            >
                                <v-icon
                                    v-if="
                                        chk_export_engineer_performance == false
                                    "
                                    color="teal darken-4"
                                    >mdi-file-excel</v-icon
                                >
                                <img
                                    v-if="
                                        chk_export_engineer_performance == true
                                    "
                                    src="../../assets/all/Loading.gif"
                                    style="width:6%; "
                                />
                            </v-btn>
                        </template>
                        <span>Export Data</span>
                    </v-tooltip>
                </v-col>
                <v-col cols="12" v-if="data_engineer_performance.length == 0">
                    <div class="headline">- No results found</div>
                </v-col>
                <v-col
                    cols="12"
                    class="mar-t-30"
                    v-if="data_engineer_performance.length != 0"
                >
                    <v-simple-table
                        class="table-inv"
                        fixed-header
                        height="700px"
                    >
                        <template v-slot:default>
                            <thead>
                                <tr class="col-tr-1">
                                    <th class="text-center" rowspan="2">
                                        Branch / Zone
                                    </th>
                                    <th
                                        class="text-center"
                                        :colspan="
                                            data_engineer_performance
                                                .case_status_group.length
                                        "
                                    >
                                        Case Status
                                    </th>
                                </tr>
                                <tr class="col-tr-1">
                                    <th
                                        class="text-center"
                                        v-for="(row2,
                                        index2) in data_engineer_performance.case_status_group"
                                        :key="index2"
                                    >
                                        {{ row2 }}
                                    </th>
                                </tr>
                            </thead>
                            <tbody
                                v-for="(r2,
                                i2) in data_engineer_performance.summary"
                                :key="i2"
                            >
                                <tr class="bg-tr-1">
                                    <td
                                        :colspan="
                                            data_engineer_performance
                                                .case_status_group.length + 1
                                        "
                                    >
                                        <b>{{ r2.branch_name }}</b>
                                    </td>
                                </tr>
                                <tr
                                    v-for="(r22, i22) in r2.engineer"
                                    :key="i22"
                                >
                                    <td>{{ r22.engineer_name }}</td>
                                    <td
                                        v-for="(r222, i222) in r22.case_status"
                                        :key="i222"
                                        class="text-right"
                                    >
                                        <b> {{ r222.num_cases }}</b>
                                    </td>
                                </tr>
                            </tbody>
                        </template>
                    </v-simple-table>
                </v-col>
            </v-row>
        </div>

        <v-row justify="center">
            <v-dialog
                v-model="dialog"
                fullscreen
                hide-overlay
                transition="dialog-bottom-transition"
            >
                <v-card>
                    <v-toolbar dark color="primary">
                        <v-btn icon dark @click="close_dialog()">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                        <!-- <v-toolbar-title>Settings</v-toolbar-title> -->
                        <v-spacer></v-spacer>
                    </v-toolbar>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12">
                                <table-view-case
                                    :condition="condition"
                                    :data_case="detail_agging_case"
                                    :casetab="casetab"
                                />
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </v-row>
    </div>
</template>

<script>
import axios from "axios"
import { mapState, mapMutations } from "vuex"

import AreaChart from "../Expense/components/AreaChart.vue"
import PieChart from "../Expense/components/PieChart.vue"
import BarChart from "../Expense/components/BarChart.vue"
import RadarChart from "../Expense/components/RadarChart.vue"
import LineChart from "../Expense/components/LineChart.vue"
import TableViewCase from "../Project/components/TableViewCase"

import ViewAttachInformation from "../Project/components/ViewAnnounce"

let url = `${process.env.VUE_APP_ROOT_API}/api/`

export default {
    beforeMount() {
        this.tk = {
            headers: { Authorization: "Bearer " + localStorage.token },
        }
        this.get_filter()
        this.chk_loading = true
    },
    mounted() {
        this.get_summary_case()
        this.chk_data_engineer_performance = true
    },
    components: {
        AreaChart,
        PieChart,
        BarChart,
        RadarChart,
        LineChart,
        ViewAttachInformation,
        "table-view-case": TableViewCase,
    },
    computed: {
        ...mapState(["isLoading"]),
        dateRangeText2() {
            this.form_admin_performance.date.sort((a, b) => {
                return new Date(a) - new Date(b)
            })
            return this.form_admin_performance.date.join(" ~ ")
        },
        dateRangeText3() {
            this.form_engineer_performance.date.sort((a, b) => {
                return new Date(a) - new Date(b)
            })
            return this.form_engineer_performance.date.join(" ~ ")
        },

        likesAllProject() {
            return (
                this.form_agging_case.project.length ===
                this.data_filter.projects.length
            )
        },
        likesSomeProject() {
            return (
                this.form_agging_case.project.length > 0 &&
                !this.likesAllProject
            )
        },
        icon() {
            if (this.likesAllProject) return "mdi-close-box"
            if (this.likesSomeProject) return "mdi-minus-box"
            return "mdi-checkbox-blank-outline"
        },
        likesAllZone() {
            return (
                this.form_agging_case.branch.length ===
                this.data_filter.branchs.length
            )
        },
        likesSomeZone() {
            return this.form_agging_case.branch.length > 0 && !this.likesAllZone
        },
        icon_zone() {
            if (this.likesAllZone) return "mdi-close-box"
            if (this.likesSomeZone) return "mdi-minus-box"
            return "mdi-checkbox-blank-outline"
        },

        likesAllZone2() {
            return (
                this.form_engineer_performance.branch.length ===
                this.data_filter.branchs.length
            )
        },
        likesSomeZone2() {
            return (
                this.form_engineer_performance.branch.length > 0 &&
                !this.likesAllZone
            )
        },
        icon_zone2() {
            if (this.likesAllZone2) return "mdi-close-box"
            if (this.likesSomeZone2) return "mdi-minus-box"
            return "mdi-checkbox-blank-outline"
        },
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        async get_summary_case(st) {
            this.data_summary_case = []
            await axios
                .post(url + "dashboard/summary", this.form_agging_case, this.tk)
                .then((response) => {
                    this.data_summary_case = response.data
                    this.get_pending_case(st)
                })
                .catch((error) => {
                    console.log(error)
                    return false
                })
        },
        async get_pending_case(st) {
            this.data_agging_case = []
            await axios
                .post(
                    url + "dashboard/case-agging",
                    this.form_agging_case,
                    this.tk
                )
                .then((response) => {
                    this.data_agging_case = response.data
                    if (st != 1) {
                        this.get_admin_performance()
                    }
                })
                .catch((error) => {
                    console.log(error)
                    return false
                })
        },
        async get_admin_performance(st) {
            this.data_admin_performance = []
            await axios
                .post(
                    url + "dashboard/admin-performance",
                    this.form_admin_performance,
                    this.tk
                )
                .then((response) => {
                    this.data_admin_performance = response.data
                    if (st != 1) {
                        this.get_engineer_performance()
                    }
                })
                .catch((error) => {
                    console.log(error)
                    return false
                })
        },
        async get_engineer_performance() {
            this.chk_data_engineer_performance = true

            await axios
                .post(
                    url + "dashboard/engineer-performance",
                    this.form_engineer_performance,
                    this.tk
                )
                .then((response) => {
                    this.chk_data_engineer_performance = false
                    this.data_engineer_performance = response.data
                })
                .catch((error) => {
                    console.log(error)
                    return false
                })
        },
        async export_engineer_performance() {
            this.chk_export_engineer_performance = true
            await axios({
                url: `${process.env.VUE_APP_ROOT_API}/api/dashboard/engineer-performance/export`,
                method: "POST",
                responseType: "blob",
                data: this.form_engineer_performance,
                headers: { Authorization: "Bearer " + localStorage.token },
            }).then((response) => {
                this.chk_export_engineer_performance = false
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")

                fileLink.href = fileURL
                fileLink.setAttribute("download", "engineer_performance.xlsx")
                document.body.appendChild(fileLink)

                fileLink.click()
            })
        },
        change_statusall(index_sum) {
            this.chk_active_all = index_sum
            // this.dialog = true
        },
        get_date(st) {
            if (st == 2) {
                if (this.dateRangeText2.length === 23) {
                    this.get_admin_performance(1)
                    this.menudate2 = false
                }
            } else if (st == 3) {
                if (this.dateRangeText3.length === 23) {
                    this.get_engineer_performance()
                    this.menudate3 = false
                }
            }
        },
        async get_filter() {
            await axios
                .get(url + "dashboard/get-filter", this.tk)
                .then((response) => {
                    this.data_filter.branchs = response.data.branchs
                    this.data_filter.projects = response.data.projects
                })
        },
        toggle() {
            this.$nextTick(() => {
                if (this.likesAllProject) {
                    this.form_agging_case.project = []
                    this.get_summary_case(1)
                } else {
                    this.form_agging_case.project = []
                    this.data_filter.projects.map((each) => {
                        this.form_agging_case.project.push(each.project_id)
                    })
                    this.get_summary_case(1)
                }
            })
        },
        toggle_zone() {
            this.$nextTick(() => {
                if (this.likesAllZone) {
                    this.form_agging_case.branch = []
                    this.get_summary_case(1)
                } else {
                    this.form_agging_case.branch = []
                    this.data_filter.branchs.map((each) => {
                        this.form_agging_case.branch.push(each.branch_id)
                    })
                    this.get_summary_case(1)
                }
            })
        },

        toggle_zone2() {
            this.$nextTick(() => {
                if (this.likesAllZone2) {
                    this.form_engineer_performance.branch = []
                    this.get_engineer_performance(1)
                } else {
                    this.form_engineer_performance.branch = []
                    this.data_filter.branchs.map((each) => {
                        this.form_engineer_performance.branch.push(
                            each.branch_id
                        )
                    })
                    this.get_engineer_performance(1)
                }
            })
        },
        async change_agging(data1, data2, data3, num) {
            if (num > 0) {
                let send = {
                    case_status: data2,
                    project_name: data3,
                    agging: this.convert_data(data1),
                    branch: this.form_agging_case.branch,
                }

                await axios
                    .post(
                        url + "dashboard/case-agging/case-detail",
                        send,
                        this.tk
                    )
                    .then((response) => {
                        this.casetab = true
                        this.detail_agging_case = response
                        console.log(response)
                    })
                    .catch((error) => {
                        console.log(error, 'err')
                        return false
                    })
                this.dialog = true
            }
        },
        close_dialog() {
            this.casetab = false
            this.dialog = false
        },
        convert_data(data) {
            if (data == 0) {
                return "0"
            } else if (data == 1) {
                return "1"
            }
            if (data == 2) {
                return "2-3"
            }
            if (data == 3) {
                return "4-7"
            }
            if (data == 4) {
                return "8-14"
            }
            if (data == 5) {
                return "15-29"
            }
            if (data == 6) {
                return "30+"
            }
            if (data == 7) {
                return "total"
            }
        },
    },
    data: () => ({
        count_loading: 1,
        chk_loading: false,
        tk: null,
        data_summary_case: [],
        data_agging_case: [],
        detail_agging_case: [],
        data_admin_performance: [],
        data_engineer_performance: [],
        value: [0, 423],
        chk_active_all: null,
        dialog: false,
        colorx: [
            "rgb(0, 82, 0)",
            "rgb(13, 97, 13)",
            "rgb(32, 126, 32)",
            "rgb(252, 187, 66)",
            "rgb(245, 118, 33)",
            "rgb(245, 75, 33)",
            "rgb(214, 43, 0)",
        ],
        menudate: false,
        form_agging_case: {
            project: [],
            branch: [],
            // date: [
            //     new Date().toISOString().substr(0, 10),
            //     new Date().toISOString().substr(0, 10),
            // ],
        },
        menudate2: false,
        form_admin_performance: {
            date: [
                new Date().toISOString().substr(0, 10),
                new Date().toISOString().substr(0, 10),
            ],
        },
        chk_data_engineer_performance: false,
        menudate3: false,
        form_engineer_performance: {
            date: [
                new Date().toISOString().substr(0, 10),
                new Date().toISOString().substr(0, 10),
            ],
            branch: [],
        },
        data_filter: {
            branchs: [],
            projects: [],
        },
        role_name: localStorage.role_name,
        chk_export_engineer_performance: false,
        condition: {
            team: "Uc",
            status: "ViewDetail",
        },
        casetab: false,
    }),
}
</script>
<style scoped>
.bg-tr-1 {
    background-color: rgb(217, 233, 247) !important;
}
.fix-td-1 {
    font-weight: bold !important;
}
.theme--light.v-data-table.v-data-table--fixed-header thead th {
    background-color: rgb(92, 157, 253);
    color: #fff !important;
}
</style>
